// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Newsletter Section */
.Subscribe_newsletterSection__GoXhS {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 3rem;
    padding: 2rem 1rem;
  }
  
  .Subscribe_newsletterTitle__p\\+cef {
    font-size: 3rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  .Subscribe_newsletterText__RWRQa {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 1rem;
    max-width: 600px;
  }
  
  .Subscribe_newsletterForm__4OXcG {
    position: relative;
    z-index: 100;
    display: flex;
    margin-top: 1rem;
    padding: 4px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background-color: rgba(255, 255, 255, 0.05);
    gap: 1rem;
    width: 100%;
    max-width: 500px;
    transition: border-color 0.3s ease;
  }
  
  .Subscribe_emailInput__AJAId {
    flex: 1 1;
    padding: 0.8rem 1rem;
    border: none;
    background-color: rgba(255, 255, 255, 0);
    color: white;
    border-radius: 4px 0 0 4px;
    font-size: 0.9rem;
    outline: none;
  }
  
  .Subscribe_emailInput__AJAId::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
  
  .Subscribe_emailInput__AJAId:focus {
    outline: none;
  }
  
  .Subscribe_emailInput__AJAId:focus-within + .Subscribe_subscribeButton__7cWAx,
  .Subscribe_emailInput__AJAId:focus + .Subscribe_subscribeButton__7cWAx {
    outline: none;
  }
  
  .Subscribe_newsletterForm__4OXcG:focus-within {
    border: 1px solid white;
  }
  
  .Subscribe_subscribeButton__7cWAx {
    padding: 0 1.5rem;
    background: linear-gradient(to right, #00f5d4, #0094ff);
    color: black;
    border: none;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    letter-spacing: 0.1rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    clip-path: polygon(
      10% 0%,
      100% 0%,
      100% 70%,
      90% 100%,
      0% 100%,
      0% 30%
    );
  }
  .Subscribe_subscribeButton__7cWAx:hover {
    background: white;
    color: black;
  }

  .Subscribe_subscribeButton__7cWAx:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  @media (max-width: 576px) {
    .Subscribe_linksColumn__7sxpd {
      flex: 0 0 100%;
    }
    
    .Subscribe_socialLinks__6SlqZ {
      justify-content: center;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/Subscribe/Subscribe.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,0CAA0C;IAC1C,2CAA2C;IAC3C,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,SAAO;IACP,oBAAoB;IACpB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,uDAAuD;IACvD,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,qDAAqD;IACrD;;;;;;;KAOC;EACH;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,uBAAuB;IACzB;EACF","sourcesContent":["/* Newsletter Section */\n.newsletterSection {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    margin-bottom: 3rem;\n    padding: 2rem 1rem;\n  }\n  \n  .newsletterTitle {\n    font-size: 3rem;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n  }\n  \n  .newsletterText {\n    font-size: 1rem;\n    color: rgba(255, 255, 255, 0.7);\n    margin-bottom: 1rem;\n    max-width: 600px;\n  }\n  \n  .newsletterForm {\n    position: relative;\n    z-index: 100;\n    display: flex;\n    margin-top: 1rem;\n    padding: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    background-color: rgba(255, 255, 255, 0.05);\n    gap: 1rem;\n    width: 100%;\n    max-width: 500px;\n    transition: border-color 0.3s ease;\n  }\n  \n  .emailInput {\n    flex: 1;\n    padding: 0.8rem 1rem;\n    border: none;\n    background-color: rgba(255, 255, 255, 0);\n    color: white;\n    border-radius: 4px 0 0 4px;\n    font-size: 0.9rem;\n    outline: none;\n  }\n  \n  .emailInput::placeholder {\n    color: rgba(255, 255, 255, 0.5);\n  }\n  \n  .emailInput:focus {\n    outline: none;\n  }\n  \n  .emailInput:focus-within + .subscribeButton,\n  .emailInput:focus + .subscribeButton {\n    outline: none;\n  }\n  \n  .newsletterForm:focus-within {\n    border: 1px solid white;\n  }\n  \n  .subscribeButton {\n    padding: 0 1.5rem;\n    background: linear-gradient(to right, #00f5d4, #0094ff);\n    color: black;\n    border: none;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    letter-spacing: 0.1rem;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    clip-path: polygon(\n      10% 0%,\n      100% 0%,\n      100% 70%,\n      90% 100%,\n      0% 100%,\n      0% 30%\n    );\n  }\n  .subscribeButton:hover {\n    background: white;\n    color: black;\n  }\n\n  .subscribeButton:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  @media (max-width: 576px) {\n    .linksColumn {\n      flex: 0 0 100%;\n    }\n    \n    .socialLinks {\n      justify-content: center;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newsletterSection": `Subscribe_newsletterSection__GoXhS`,
	"newsletterTitle": `Subscribe_newsletterTitle__p+cef`,
	"newsletterText": `Subscribe_newsletterText__RWRQa`,
	"newsletterForm": `Subscribe_newsletterForm__4OXcG`,
	"emailInput": `Subscribe_emailInput__AJAId`,
	"subscribeButton": `Subscribe_subscribeButton__7cWAx`,
	"linksColumn": `Subscribe_linksColumn__7sxpd`,
	"socialLinks": `Subscribe_socialLinks__6SlqZ`
};
export default ___CSS_LOADER_EXPORT___;
